import type { CityConfig } from "../city-template/types";

export const raytownMOConfig: CityConfig = {
  city: "Raytown",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "raytown-mo",
  route: "/raytown-mo",
  title: "Emergency Passport Raytown, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Raytown, MO — as fast as 24 hours. Serving Eastern Jackson County and the KC metro. A+ BBB rated registered State Dept. courier serving Raytown, southeast KC, and eastern Jackson County. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Raytown, MO",
  heroSubtitle: "Eastern Jackson County business trip to Toronto with 3 days notice? Family reunion in Germany and your passport just expired? KC metro corporate travel needs fast documents? We help Raytown residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Raytown%20Missouri%20eastern%20Jackson%20County%20suburban%20Kansas%20City%20metropolitan%20area%20tree%20lined%20streets%20residential%20neighborhoods%20350%20Highway%20commercial%20corridor%20Midwestern%20suburban%20landscape%20blue%20skies%20soft%20afternoon%20light%20professional%20drone%20photography%20Heartland%20charm&width=1800&height=700&seq=raytown-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Raytown Missouri Eastern Jackson County suburban landscape at golden hour",
  geoPosition: "38.9947;-94.4697",
  geoPlacename: "Raytown, Missouri",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 530 miles east of Raytown via I-70/I-55",
  },
  nearbyCitiesZips: [
    { name: "Raytown", zips: "64133, 64138" },
    { name: "Kansas City", zips: "64101–64199" },
    { name: "Independence", zips: "64050–64057" },
    { name: "Lee's Summit", zips: "64063, 64064, 64081, 64082, 64086" },
    { name: "Blue Springs", zips: "64014, 64015" },
    { name: "Grandview", zips: "64030" },
    { name: "Belton", zips: "64012" },
    { name: "Grain Valley", zips: "64029" },
    { name: "Oak Grove", zips: "64075" },
    { name: "Sugar Creek", zips: "64050, 64054, 64056" },
    { name: "Lone Jack", zips: "64070" },
    { name: "Greenwood", zips: "64034" },
    { name: "Lake Lotawana", zips: "64086" },
    { name: "Lake Tapawingo", zips: "64015" },
    { name: "Pleasant Hill", zips: "64080" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Eastern Jackson County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Eastern Jackson County Hub", desc: "Serving Raytown, southeast KC, Lee's Summit, and Independence" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Independence, MO", route: "/independence-mo" },
    { name: "Fast passport renewal in Blue Springs, MO", route: "/blue-springs-mo" },
    { name: "Emergency passport help in Kansas City, MO", route: "/kansas-city" },
    { name: "Urgent passport services in Lee's Summit, MO", route: "/lees-summit" },
    { name: "Same-day passport help in Chicago, IL", route: "/chicago" },
    { name: "Passport courier services in Columbia, MO", route: "/columbia-mo" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Raytown remotely via secure courier. We do not have a walk-in office in Raytown — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Eastern Jackson County and the KC metro region.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of Eastern Jackson County including Raytown, southeast Kansas City, and surrounding communities",
  serviceAreaIntro: "From the tree-lined neighborhoods of Raytown and the vibrant communities of eastern Jackson County to the historic Independence Square and the growing suburbs of Blue Springs, from the lakeside homes of Lake Lotawana to the charming small towns of Grain Valley and Oak Grove — Fast Passport Center serves the entire eastern KC metro area. We regularly help travelers from Raytown, Independence, and Blue Springs get their passports fast without the 8-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Raytown neighborhoods and the surrounding Eastern Jackson County area including Kansas City, Independence, Lee's Summit, Blue Springs, Grandview, Belton, Grain Valley, Oak Grove, and Greenwood. If you are anywhere in Eastern Jackson County, we have you covered.",
  howItWorksIntro: "Most Raytown travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Raytown travelers often face an 8-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Raytown and Eastern Jackson County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Raytown? Here are the most common ones we hear from Eastern Jackson County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Raytown travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "David W.",
      location: "Raytown, MO",
      rating: 5,
      text: "Our Cancun family vacation was in 3 days and my passport was expired. Fast Passport Center got my renewal in 31 hours. I never left Raytown. From 63rd Street to the beach in under a week — absolutely incredible service!",
      service: "Passport Renewal",
    },
    {
      name: "Cheryl D.",
      location: "Raytown, MO",
      rating: 5,
      text: "Business trip to Frankfurt with 5 days notice. Fast Passport Center's dedicated agent handled everything. The daily updates kept me calm the whole way. Best travel document service I've ever used.",
      service: "Emergency Passport",
    },
    {
      name: "Marcus J.",
      location: "Independence, MO",
      rating: 5,
      text: "Needed passport renewal for the whole family before our European vacation. Fast Passport Center got all four of us new passports in 4 days. Unbelievable service for Eastern Jackson County families!",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "raytown-1",
      name: "Raytown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10300 E 63rd St",
      city: "Raytown",
      state: "MO",
      zip: "64133",
      phone: "(816) 353-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Raytown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Raytown facility on 63rd Street. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "raytown-2",
      name: "Jackson County — Truman Courthouse",
      type: "County Government Passport Acceptance",
      address: "112 W Lexington Ave",
      city: "Independence",
      state: "MO",
      zip: "64050",
      phone: "(816) 881-4483",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "5 miles north of Raytown",
      website: "https://www.jacksongov.org",
      websiteLabel: "Jackson County Recorder",
      notes: "County seat with passport acceptance services. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "raytown-3",
      name: "Lee's Summit Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 SW Market St",
      city: "Lee's Summit",
      state: "MO",
      zip: "64063",
      phone: "(816) 524-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles south of Raytown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lee's Summit and southern Jackson County. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "raytown-4",
      name: "Blue Springs Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "500 SW South Ave",
      city: "Blue Springs",
      state: "MO",
      zip: "64014",
      phone: "(816) 229-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles east of Raytown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Blue Springs and eastern Jackson County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "raytown-5",
      name: "Kansas City — Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 W Pershing Rd",
      city: "Kansas City",
      state: "MO",
      zip: "64108",
      phone: "(816) 374-9111",
      hours: "Mon–Fri: 8:30 AM – 5:00 PM",
      distance: "12 miles northwest of Raytown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Downtown KC main post office with full passport services. Walk-ins accepted but appointments preferred.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 8 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Raytown photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Jackson County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Raytown applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Eastern Jackson County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Raytown travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Raytown." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Raytown address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Raytown before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Raytown for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 8-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Raytown?", a: "Fast Passport Center offers fast passport renewal in Raytown in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Raytown?", a: "The nearest regional passport agency to Raytown is the Chicago Passport Agency, approximately 530 miles east via I-70/I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Raytown without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Raytown?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 8 hours from Raytown — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Eastern Jackson County residents." },
    { q: "Do you serve the entire Eastern Jackson County area?", a: "Absolutely. Fast Passport Center serves all of Eastern Jackson County including Raytown, Independence, Blue Springs, Grain Valley, and surrounding areas. Our courier service works seamlessly from any address in the Kansas City metropolitan area." },
    { q: "Can I expedite a child passport in Raytown?", a: "Yes. Fast Passport Center expedites child passports in Raytown for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Eastern Jackson County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Raytown with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Raytown", address: "10300 E State Rte 350, Raytown, MO 64138", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Raytown", address: "8700 E 63rd St, Raytown, MO 64133", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Independence", address: "3925 S Lees Summit Rd, Independence, MO 64055", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — Lee's Summit", address: "1000 NE Sam Walton Ln, Lee's Summit, MO 64086", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Raytown License Office",
      address: "10012 E 63rd St, Raytown, MO 64133",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Most convenient for Raytown residents.",
      featured: true,
    },
    {
      name: "Missouri DOR — Independence License Office",
      address: "14310 E 42nd St S, Independence, MO 64055",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Full service location. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Lee's Summit License Office",
      address: "501 SE Blue Pkwy, Lee's Summit, MO 64063",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves southern Jackson County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "35 miles northwest of Raytown",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major international airport with direct flights worldwide. About 40 minutes from Raytown via I-435.",
      flightUrl: "https://www.flykc.com/",
      flightLabel: "MCI Airport",
      featured: true,
    },
    {
      code: "MKC",
      name: "Charles B. Wheeler Downtown Airport",
      distance: "15 miles northwest of Raytown",
      address: "1000 NW Lou Holland Dr, Kansas City, MO 64116",
      note: "General aviation and regional flights. About 25 minutes from Raytown via I-70.",
      flightUrl: "https://www.flymkc.com/",
      flightLabel: "MKC Airport",
      featured: false,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "250 miles east of Raytown",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major Missouri airport on the east side. About 3 hours 45 minutes from Raytown via I-70.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: false,
    },
  ],
};